// Autogenerated
// -------------
// gulpfile.js --> generateBuildInfo

export const Build = {
    version: "6.22.29 (a0748e770f4275b31075dc7ce46254a4)",
    jsVersion: "7a9b47b1c3ba95d95d4d2bb58b9248ae603f7479",
    jsSize:  197174,
    wasmVersion: "6565a5835c4d01168e4f75cc94713fd3",
    wasmSize: 3121929,
};
